import { storage } from 'BASE/common/util/util.storage';
import { getterTypes, mutationTypes, actionTypes } from 'BASE/store/types';

export default {
    name: 'WebsiteInfo',
    data: function () {
        return {
            websiteInfo: {},
            keyWebsiteInfo: storage.keys.KEY_WEBSITEINFO,
            keyWebsiteTitle: storage.keys.KEY_WEBSITE_TITLE,
        }
    },
    computed: {
        isSpeedTestPath() {
            //如是speedTest頁面並沒有配置$store 及 $router
            return !(this.$store && this.$router);
        },
    },
    methods: {
        async initWebSiteInfo() {
            await this.getWebSiteInfo();
            this.initWebSiteTitle();
            this.initIsDemoSite();
        },
        async getWebSiteInfo() {
            this.websiteInfo = storage.temp.get(this.keyWebsiteInfo);
            if (!this.websiteInfo) {
                this.websiteInfo = {};
                this.websiteInfo[this.keyWebsiteInfo] = await $.get('/api/WebSiteInfo/GetInfo');
                storage.temp.set(this.keyWebsiteInfo, this.websiteInfo);
            }
            return this.getWebSiteInfo;
        },
        async initWebSiteTitle() {
            let title = storage.temp.get(this.keyWebsiteTitle);
            if (!title) {
                this.websiteInfo = storage.temp.get(this.keyWebsiteInfo);
                title = this.websiteInfo[this.keyWebsiteInfo].WebSiteTitle;
                storage.temp.set(this.keyWebsiteTitle, title);
            }
            document.title = title;
        },
        async initIsDemoSite() {
            let _isDemoSite = storage.session.get(storage.keys.IS_DEMO_SITE);
            if (_isDemoSite == null) {
                let _IsDemoSiteResult = await $.post('/api/WebSiteInfo/IsDemoSite');
                _isDemoSite = _IsDemoSiteResult
                storage.session.set(storage.keys.IS_DEMO_SITE, _isDemoSite); 
            }

            //測速頁沒有store機制
            if (this.isSpeedTestPath == false){
                this.$store.dispatch(actionTypes.USER_INFO_DEMO_SITE, { isDemoSite: _isDemoSite });
            }
        },
    },
    created() {
        if ( !ENVIRONMENT.CORDOVA ) this.initWebSiteInfo(); //cordova目前不會用到這些資訊
    }
};